import * as React from 'react';

import Alert from '@mui/material/Alert';

import Typography from '@mui/material/Typography';


import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';

import {THEME_DE} from './Data';

//Severities: success, info, warning, error
export const alerts =[
   	{
		id: "unverbindlich",
		severity: "warning",
		messageDe: "Die Informationen in dieser Vorschau sind nicht verbindlich und ohne Gewähr.",
		messageEn: "The information in this preview is not binding and without guarantee."
    },
   	{
		id: "testmode",
		severity: "warning",
		messageDe: "Diese Seite befindet sich im Textbetrieb und Fehler in den Funktionen oder Anzeige sind möglich.",
		messageEn: "This page is in text mode and errors in the functionality of presentation are possible."
    }

];

export default function DisclaimerDe() {
	const theme = useTheme();
	
	const suppressedAlerts = localStorage.getItem("suppressAlertVersion") !== null ? JSON.parse(localStorage.getItem("suppressAlertVersion")) : [];
	
	const alertMessages = alerts.filter(al => !suppressedAlerts.includes(al.id)).map(al =>
		<Alert severity={al.severity}>
			<Typography variant='body2'>
				{theme.language === THEME_DE ?
					al.messageDe :
					al.messageEn}
			</Typography>
			<Typography align='right' variant='body2'>
			<FormControlLabel control={
				<Checkbox size="small" onChange={e => {
		            if (e.target.checked) {
						suppressedAlerts.push(al.id);
					} else {
						suppressedAlerts.splice(suppressedAlerts.indexOf(al.id), 1);
					}
		        }}/>
			} label={<Typography variant='body2'>{theme.language === THEME_DE ?
					"Nicht mehr anzeigen." :
					"Don't show again."}</Typography>} />
			</Typography>
		</Alert>
	);
	
	const [alertOpen, setAlertOpen] = React.useState(alertMessages.length !== 0);
	
  	const handleClose = () => {
    	setAlertOpen(false);
    	localStorage.setItem("suppressAlertVersion", JSON.stringify(suppressedAlerts));

  	};
	
	return <Dialog
        open={alertOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {theme.language === THEME_DE ?
					"Hinweis" :
					"Notice"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <Stack sx={{ width: '100%' }} spacing={2}>
          	{alertMessages}
          </Stack>
          </DialogContentText>
        </DialogContent>
      </Dialog>;
	
}